export default "__VITE_ASSET__RzF79Gx___"